module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("AlarmCentralSelection", "Select an alarm central") ))==null?'':__t)+
'</legend><div class="double-column" data-region="selection-container"></div></fieldset><fieldset class="button-wrap"><button data-click="selection-cancel">'+
((__t=( i18n.tc("AlarmCentralSelection", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="selection-submit" disabled="disabled">'+
((__t=( i18n.tc("AlarmCentralSelection", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
